import { useContext } from 'react';

import { 
  LongFormTextModalContext, 
  VideoModalContext, 
  MapModalContext, 
  CommentFormModalContext, 
  GalleryModalContext, 
  PosterModalContext,
  CustomFormModalContext
} from './contexts';
import { HotspotTypes } from './types';

export function useModalTriggerHandler(hotspotData, hotspotType) {
  const data = hotspotData;
  const type = hotspotType;

  const longFormTextModalContextValue = useContext(LongFormTextModalContext);
  const videoEmbedModalContextValue = useContext(VideoModalContext);
  const mapModalContextValue = useContext(MapModalContext);
  const commentFormModalContextValue = useContext(CommentFormModalContext);
  const galleryModalContextValue = useContext(GalleryModalContext);
  const posterModalContextValue = useContext(PosterModalContext);
  const customFormModalContextValue = useContext(CustomFormModalContext);
  
  function defaultClickHandler() {
    if (type === HotspotTypes.LongFormText) {
      longFormTextModalContextValue.setMarkdown(data.markdown);
      longFormTextModalContextValue.setIsOpen(true);
    }
    else if (type === HotspotTypes.VideoEmbed) {
      videoEmbedModalContextValue.setUrl(data.url);
      videoEmbedModalContextValue.setIsOpen(true);
    }
    else if (type === HotspotTypes.MapEmbed) {
      mapModalContextValue.setCenter(data.center.lat, data.center.lng);
      mapModalContextValue.setIsOpen(true);
    }
    else if (type === HotspotTypes.CommentForm) {
      commentFormModalContextValue.setPostUrl(data.postUrl);
      commentFormModalContextValue.setIsOpen(true);
    }
    else if (type === HotspotTypes.Gallery) {
      galleryModalContextValue.setImages(data.images);
      galleryModalContextValue.setMarkdownCaptions(data.markdownCaptions)
      galleryModalContextValue.setModalStyle(data.modalStyle);
      galleryModalContextValue.setIsOpen(true);
    }
    else if (type === HotspotTypes.Poster) {
      posterModalContextValue.setImage(data.image);
      posterModalContextValue.setIsOpen(true);
      posterModalContextValue.setLinkText(data.linkText);
      posterModalContextValue.setPdfLink(data.pdfLink);
      posterModalContextValue.setExtraButtons(data.extraButtons);
      posterModalContextValue.setZoomPan(data.zoomPan);
      posterModalContextValue.setExtraWide(data.extraWide);
    }
    else if (type === HotspotTypes.CustomForm) {
      customFormModalContextValue.setIsOpen(true);
      customFormModalContextValue.setTitle(data.title);
      customFormModalContextValue.setAction(data.action);
      customFormModalContextValue.setMethod(data.method);
      customFormModalContextValue.setPartsConfig(data.partsConfig);
    }
  }

  return defaultClickHandler;
}